import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Avatar } from '@/components/ui/Image/Avatar';
/**
 * コンサルタントの画像を表示するコンポーネント
 * @constructor
 */
export const CSearchProImage = (props) => {
    const { alt, className = '', isBlur, src = '' } = props;
    return (_jsx(Avatar, { alt: alt, className: clsx('border-2 border-solid border-gray-50', className), isBlur: isBlur, size: 'none', src: src }));
};
